"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _generatePreviewHash = _interopRequireDefault(require("./generatePreviewHash.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Boilerplate = window.cccisd.boilerplate;
var _default = exports["default"] = function _default(assignmentId) {
  var hash = (0, _generatePreviewHash["default"])(assignmentId);
  return Boilerplate.url("/quest/preview/quest/".concat(assignmentId, "/").concat(hash));
};